import { toastError, toastSuccess } from "../../../../utils/pageUtil/toast";

export async function copyToClipboard(value: string, successMessage: string) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = value;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
    toastSuccess(successMessage);
  } catch {
    toastError(value);
  }
}
